import { queryOptions } from "@tanstack/react-query";
import { adminList, adminSettings, adminStats, getMe } from "./admin.functions";

export const meQuery = () =>
  queryOptions({
    queryKey: ["admin", "me"],
    queryFn: () => getMe(),
    staleTime: 60_000,
    retry: false,
  });

export const adminListQuery = (table: string, limit?: number) =>
  queryOptions({
    queryKey: ["admin", "list", table, limit ?? null],
    queryFn: () => adminList({ data: { table: table as never, limit } }),
    staleTime: 5_000,
  });

export const adminSettingsQuery = () =>
  queryOptions({
    queryKey: ["admin", "settings"],
    queryFn: () => adminSettings(),
    staleTime: 5_000,
  });

export const adminStatsQuery = () =>
  queryOptions({
    queryKey: ["admin", "stats"],
    queryFn: () => adminStats(),
    staleTime: 5_000,
  });
